// extracted by mini-css-extract-plugin
module.exports = {"reassignModal":"styles_reassignModal__3Kg4z","reassignBody":"styles_reassignBody__RY9Td"};